// extracted by mini-css-extract-plugin
module.exports = {"pushoverHeader":"howto-pushover_pushoverHeader_1XgDQ","appLogo":"howto-pushover_appLogo_3uyG3","appScreenshot":"howto-pushover_appScreenshot_10cdU"};